import type { FlightLinkCandidate } from '../../types/api';
import type { useTranslation } from '../../i18n';

type Translate = ReturnType<typeof useTranslation>['t'];

/**
 * "2 min from the CSV name" / "4 min from the first sample (UTC)", or '' when
 * the log's name spells no start time. Shared by the dialog and the upload
 * prompt so the two say the same thing about one match.
 */
export function startEvidence(t: Translate, c: FlightLinkCandidate): string {
  if (c.delta_minutes === null || !c.clock) return '';
  return t(c.clock === 'log_name' ? 'flightLinks.deltaLogName' : 'flightLinks.deltaFirstSample', {
    minutes: String(c.delta_minutes),
  });
}
